<template>
  <v-container fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-carousel
          v-model="model"
          cycle
          :height="carouselHeight"
          :hide-delimiters="carouselHeight < 400"
        >
          <v-carousel-item
            v-for="(item, index) in items"
            :key="index"
            :src="item.src"
            transition="fade-transition"
          >
            <v-overlay value="true" absolute>
              <v-row
                class="fill-height white--text"
                align="center"
                justify="center"
              >
                <div v-if="carouselHeight >= 200" class="text-h2">
                  {{ item.text }}
                  <v-spacer></v-spacer>
                  <v-btn
                    x-large
                    class="primary white--text"
                    outlined
                    :to="item.link"
                  >
                    Hier klicken
                  </v-btn>
                </div>
              </v-row>
            </v-overlay>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="mt-4">
      <v-col cols="12">
        <div class="presse-header">
          <span class="presse-header-bar"></span>
          <h1 class="presse-header-title">
            Judo in Garbsen – SC Budokwai Garbsen e.V.
          </h1>
        </div>
        <p class="intro-text mt-3 mb-0">
          Der SC Budokwai Garbsen e.V. ist ein Judoverein in Garbsen bei
          Hannover. Wir bieten Judotraining für Kinder, Jugendliche und
          Erwachsene – vom ersten Fallschultraining bis zur
          Wettkampfvorbereitung. Trainiert wird an Schultagen in der Sporthalle
          der IGS Garbsen und in der Turnhalle Stelingen. Ein Probetraining ist
          bei uns jederzeit möglich und kostenlos – alle Zeiten findet ihr im
          <router-link to="/trainingsplan">Trainingsplan</router-link>.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <!---
        <v-alert
          class="ma-0"
          type="error"
        >
          Wetterbedingt fällt das Training am Montag den 12.01. aus. Die Turnhallen sind gesperrt.
        </v-alert>
        --->
        <!---
        <v-alert
          class="ma-0"
          type="warning"
        >
          Hallo Welt!
        </v-alert>
        --->
      </v-col>
    </v-row>
    <v-row v-if="presseArtikel.length" class="mt-8">
      <v-col cols="12" class="pb-2">
        <div class="presse-header">
          <span class="presse-header-bar"></span>
          <h2 class="presse-header-title">Presse</h2>
        </div>
      </v-col>
      <v-col
        v-for="(a, i) in presseArtikel"
        :key="'presse-' + i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          class="presse-card fill-height d-flex flex-column"
          :class="{ 'presse-card--linked': a.link }"
          flat
          :href="a.link || undefined"
          :target="a.link ? '_blank' : undefined"
          rel="noopener"
        >
          <div class="presse-img-wrap">
            <v-img
              :src="a.src"
              :aspect-ratio="16 / 9"
              class="presse-img"
              gradient="to top, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0) 45%"
            ></v-img>
            <v-icon v-if="a.link" class="presse-link-badge" small>
              mdi-open-in-new
            </v-icon>
          </div>
          <v-card-text v-if="a.text" class="presse-body">
            <p class="presse-text mb-0">{{ a.text }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="4">
        <v-img src="/spkasse.png" alt="Gefördert durch die Sparkasse"> </v-img>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="mt-6">
      <v-col
        v-for="(s, i) in $store.state.socials"
        :key="i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          class="social-card white--text"
          :class="s.gradient"
          hover
          :elevation="6"
        >
          <v-card-text class="py-4 px-5">
            <div class="d-flex align-center mb-2">
              <v-icon medium class="mr-2 white--text">{{ s.icon }}</v-icon>
              <div>
                <div class="subtitle-1 font-weight-bold">{{ s.name }}</div>
                <div class="caption white--text text--lighten-4">
                  {{ s.handle }}
                </div>
              </div>
            </div>

            <div
              class="caption mb-3"
              :style="{
                color: s.gradient.includes('bg-tiktok') ? '#fff' : '#222',
                textShadow: '0 1px 3px rgba(0,0,0,0.6)',
              }"
            >
              {{ s.tagline }}
            </div>

            <v-btn
              :href="s.url"
              target="_blank"
              rel="noopener"
              small
              outlined
              class="white--text"
              block
            >
              <v-icon left small>{{ s.icon }}</v-icon>
              {{ s.cta }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import presseArtikel from "@/data/presse";

export default {
  name: "Home",
  data: () => ({
    model: 0,
    items: [
      {
        src: "/Neuigkeiten1.jpg",
        text: "Aktueller Trainingsplan",
        link: "/trainingsplan",
      },
      { src: "/Header1.jpg", text: "Neuer Sportwart", link: "/vorstand" },
    ],
    presseArtikel,
  }),
  methods: {
    openLink(link) {
      window.open(link);
    },
  },
  computed: {
    carouselHeight() {
      const bp = this.$vuetify.breakpoint;
      if (bp.xs) return 100;
      if (bp.sm) return 150;
      if (bp.md) return 200;
      return 200;
    },
  },
};
</script>
<style scoped>
.social-card {
  border-radius: 16px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  min-height: 160px; /* angenehm kompakt */
}
.social-card:hover {
  transform: translateY(-1px);
}

.bg-instagram {
  background: radial-gradient(
    circle at 30% 107%,
    #fdf497 0%,
    #fd5949 45%,
    #d6249f 60%,
    #285aeb 90%
  );
}
.bg-facebook {
  background: linear-gradient(135deg, #1877f2 0%, #0e5dc1 100%);
}
.bg-tiktok {
  background: radial-gradient(
      70% 100% at 15% 15%,
      rgba(0, 255, 255, 0.6),
      rgba(0, 255, 255, 0) 60%
    ),
    radial-gradient(
      70% 100% at 85% 85%,
      rgba(255, 0, 80, 0.6),
      rgba(255, 0, 80, 0) 60%
    ),
    linear-gradient(135deg, #111 0%, #222 100%);
}

.presse-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.presse-header-bar {
  display: inline-block;
  width: 5px;
  height: 28px;
  background: #008000;
  border-radius: 3px;
}
.presse-header-title {
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0;
  color: #1f1f1f;
}

.presse-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.presse-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.06);
}
.presse-img-wrap {
  overflow: hidden;
  position: relative;
}
.presse-link-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  color: #008000 !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.presse-card--linked {
  cursor: pointer;
  text-decoration: none;
}
.presse-card--linked:hover {
  text-decoration: none;
}
.presse-img {
  transition: transform 0.45s ease;
}
.presse-card:hover .presse-img {
  transform: scale(1.04);
}
.presse-body {
  padding: 20px 22px 22px !important;
  flex-grow: 1;
}
.presse-text {
  white-space: pre-line;
  color: #2c2c2c;
  font-size: 0.975rem;
  line-height: 1.6;
}

.intro-text {
  color: #2c2c2c;
  font-size: 0.975rem;
  line-height: 1.6;
  max-width: 80ch;
}
.intro-text a {
  color: #008000;
  font-weight: 600;
}
</style>
